"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = Badge;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
// Pill caption badge. Use for status / category labels. For the three product-line
// badges (permits / logbook / water), prefer the dedicated SubscriptionBadge components
// — they encode the semantic intent directly.
const toneStyles = {
    neutral: 'bg-neutral-50 text-neutral-700 border-neutral-100',
    primary: 'bg-primary-50 text-primary-800 border-primary-100',
    info: 'bg-primary-50 text-primary-800 border-primary-100',
    success: 'bg-sup-green-50 text-sup-green-700 border-sup-green-200',
    warning: 'bg-sup-yellow-50 text-sup-yellow-700 border-sup-yellow-300',
    danger: 'bg-sup-red-50 text-sup-red-700 border-sup-red-200',
    permits: 'bg-badge-permits-bg text-badge-permits-fg border-badge-permits-bd',
    logbook: 'bg-badge-logbook-bg text-badge-logbook-fg border-badge-logbook-bd',
    water: 'bg-badge-water-bg text-badge-water-fg border-badge-water-bd'
};
function Badge(_a) {
    var { tone = 'neutral', dot, uppercase, className, children } = _a, props = __rest(_a, ["tone", "dot", "uppercase", "className", "children"]);
    return ((0, jsx_runtime_1.jsxs)("span", Object.assign({}, props, { className: (0, utils_1.cn)('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-bold leading-none', uppercase ? 'uppercase tracking-[0.08em]' : '', toneStyles[tone], className), children: [dot ? (0, jsx_runtime_1.jsx)("span", { "aria-hidden": 'true', className: 'h-1.5 w-1.5 rounded-full bg-current' }) : null, children] })));
}
